
import React, { useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../Assets/Css/HasplAgriFacility.css';
import '../Assets/Css/services.css';
import '../Assets/Css/home.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

import {
  FaGraduationCap, FaBook, FaLeaf, FaChalkboardTeacher,
  FaIndustry, FaSeedling, FaFlask, FaBoxOpen, FaCarrot,
  FaTree, FaGlobe, FaListUl, FaUsers, FaMicroscope,
  FaNewspaper, FaBriefcase, FaMoneyBillWave, FaHome,
  FaBalanceScale, FaUserTie, FaClock, FaLaptop
} from 'react-icons/fa';

const features = [
  { icon: <FaGraduationCap />, text: "Government-approved Diploma in Agriculture" },
  { icon: <FaBook />, text: "Study guidance for agriculture in India & abroad " },
  { icon: <FaLeaf />, text: "Expert-led training in organic farming" },
  { icon: <FaChalkboardTeacher />, text: "Coaching for competitive and research-based entrance exams" },
  { icon: <FaIndustry />, text: "Support in setting up Agri-based industries" },
  { icon: <FaSeedling />, text: "High-quality seeds supply" },
  { icon: <FaFlask />, text: "Bio-certified pesticides" },
  { icon: <FaBoxOpen />, text: "Vermicompost training & setup support" },
  { icon: <FaCarrot />, text: "Rooftop vegetable gardening solutions" },
  { icon: <FaTree />, text: "Landscaping & garden design services" },
  { icon: <FaGlobe />, text: "India’s largest Agri community " },
  { icon: <FaListUl />, text: "Pan-India Digital listing of Agri products and inputs" },
  { icon: <FaUsers />, text: "Entrepreneurship support – Agri Champions Ecosystem" },
  { icon: <FaMicroscope />, text: "R&D Centre for agricultural challenges – Hiranand Krishi Anusandhan Kendra" },
  { icon: <FaBook />, text: "Agricultural books hub for students & professionals" },
  { icon: <FaNewspaper />, text: "Agri innovation news – Hiranand Krishi Samachara Online" },
  { icon: <FaBriefcase />, text: "Agriculture-specific job platform " },
  { icon: <FaChalkboardTeacher />, text: "Goat farming training" },
  { icon: <FaMoneyBillWave />, text: "Financial consultancy for Agri entrepreneurs" },
  { icon: <FaHome />, text: "Greenhouse vegetable gardening guidance" },
  { icon: <FaBalanceScale />, text: "Legal advisory for Agri laws and compliance" },
  { icon: <FaUserTie />, text: "Agri Experts Zone – Share knowledge, earn, and get expert advice" },
  { icon: <FaClock />, text: "24/7 Agri support services" },
  { icon: <FaLaptop />, text: "Online agriculture education " }
];

const HasplAgriFacility = () => {

   const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div style={{ minHeight: '100vh' }}>
      {/* Banner Section */}
      <div className="bannerefacilties-agrisection d-flex align-items-center justify-content-center">
        <div className="bannerecommer-overlay text-center" data-aos="zoom-in">
          <h2 className="banner1-title"> HASPL Agri Facility</h2>
          <p className="banner1-subtitle" style={{ maxWidth: '700px' }} data-aos="zoom-in" data-aos-delay="200">
            Nurturing agri excellence through training, innovation, and community — empowering farmers, students & entrepreneurs across India.
          </p>
        </div>
      </div>

      {/* Features Section */}
      <section className="py-5 bg-light">
        <Container>
          <Row className="text-center mb-5" data-aos="fade-down">
            <Col>
              <h3 className="fw-bold section-title text-center">
                HASPL <span style={{ color: '#16343E' }}>Agri Facility</span>
              </h3>
              <p className="text-muted mx-auto" style={{ maxWidth: 720 }}>
                Empowering Farmers, Entrepreneurs & Agri Students
              </p>
            </Col>
          </Row>

          <Row className="g-4">
            {features.map((item, index) => (
              <Col key={index} lg={4} md={6} sm={12} data-aos="fade-up" data-aos-delay={index * 50}>
                <Card className="shadow-sm h-100 feature-agricard text-center p-3 border-0 rounded-4">
                  <div className="icon-box mb-3" style={{ fontSize: '2rem', color: '#3c8c5a' }}>
                    {item.icon}
                  </div>
                  <Card.Body>
                    <Card.Text className="text-dark fw-medium" style={{ fontSize: '1rem' }}>
                      {item.text}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

 <section className="py-5 bg-white">
        <Container>
          <Row className="justify-content-center text-center">
            <Col lg={8}>
              <h4 className="fw-bold mb-3">Want to know more?</h4>
              <p className="text-muted mb-4">
                For more information, please contact us or fill the form attached herewith.
              </p>
              <button
                className="btn btn-success px-4 py-2 rounded-pill"
                onClick={() => navigate('/contact')}
              >
                Contact Us
              </button>
            </Col>
          </Row>
        </Container>
      </section>


    </div>
  );
};

export default HasplAgriFacility;
